import { ChevronRight, type LucideIcon } from "lucide-react";

import {
    SidebarGroup,
    SidebarMenu,
    SidebarMenuButton,
    SidebarMenuItem,
    SidebarMenuSub,
    SidebarMenuSubButton,
    SidebarMenuSubItem,
    useSidebar,
} from "@/components/ui/sidebar";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";
import { Link, useLocation } from "react-router";
import { cn } from "@/lib/utils";

export function NavMain({
    items,
}: {
    items: {
        title: string;
        url: string;
        icon?: LucideIcon;
        isActive?: boolean;
        items?: {
            title: string;
            url: string;
        }[];
    }[];
}) {
    const location = useLocation();
    const sidebar = useSidebar();

    const handleSidebarMenuButtonClick = () => {
        if (sidebar.isMobile && sidebar.open) {
            sidebar.toggleSidebar();
        }
    };

    return (
        <SidebarGroup>
            <SidebarMenu className="mt-4">
                {items.map((item) =>
                    item.items && item.items.length > 0 ? (
                        <Collapsible key={item.title} asChild defaultOpen={item.isActive} className="group/collapsible">
                            <SidebarMenuItem className="mb-4">
                                <CollapsibleTrigger asChild>
                                    <SidebarMenuButton tooltip={item.title} className="gap-4">
                                        {item.icon && <item.icon />}
                                        <span className="text-[1rem] font-semibold">{item.title}</span>
                                        <ChevronRight className="ml-auto transition-transform duration-200 group-data-[state=open]/collapsible:rotate-90" />
                                    </SidebarMenuButton>
                                </CollapsibleTrigger>
                                <CollapsibleContent>
                                    <SidebarMenuSub>
                                        {item.items?.map((subItem) => (
                                            <SidebarMenuSubItem
                                                key={subItem.title}
                                                className={cn(location.pathname.includes(subItem.url) && "bg-blue-100")}
                                            >
                                                <SidebarMenuSubButton asChild>
                                                    <Link to={subItem.url}>
                                                        <span className="text-[0.9rem] font-semibold">{subItem.title}</span>
                                                    </Link>
                                                </SidebarMenuSubButton>
                                            </SidebarMenuSubItem>
                                        ))}
                                    </SidebarMenuSub>
                                </CollapsibleContent>
                            </SidebarMenuItem>
                        </Collapsible>
                    ) : (
                        <SidebarMenuItem
                            key={item.title}
                            className={cn(location.pathname.includes(`${item.url.split("?")[0]}`) && "bg-blue-100", "rounded-md mb-2")}
                        >
                            <SidebarMenuButton asChild tooltip={item.title} className="gap-4">
                                <Link to={item.url} onClick={handleSidebarMenuButtonClick}>
                                    {item.icon && <item.icon />}
                                    <span className="text-[1rem] font-semibold text-ellipsis whitespace-nowrap overflow-hidden">{item.title}</span>
                                </Link>
                            </SidebarMenuButton>
                        </SidebarMenuItem>
                    )
                )}
            </SidebarMenu>
        </SidebarGroup>
    );
}
